import { createSlice } from '@reduxjs/toolkit';

export enum FeatureTypes {
    'POINT' = 1,
    'LINESTRING' = 2,
    'POLYGON' = 3,
    'NONE' = 0
}

export enum DrawSource {
    'DEFAULT' = 1,
    'MAP' = 2,
    'PANO' = 3,
    '3D' = 4
}

export enum DrawTypes {
    'DEFAULT' = 0,
    'POINT' = 1,
    'LINESTRING' = 2,
    'POLYGON' = 3,
    'CLEAR' = 4
}

export class DrawFeature {

    coordinates;
    type;
    source;

    constructor(coordinates: Array<[]>, type: FeatureTypes, source: DrawSource) {
        this.coordinates = coordinates;
        this.type = type;
        this.source = source;
    }
}

export interface DrawState {
    drawType: DrawTypes;
    drawFeature: DrawFeature | undefined;
    text: boolean;
}

const initialState: DrawState = {
    drawType: DrawTypes.DEFAULT,
    drawFeature: undefined,
    text: true
};

export const selectionSlice = createSlice({
    name: 'selectionState',
    initialState,
    reducers: {
        startDrawing: (state: DrawState, action) => {
            state.drawType = action.payload;
            switch (state.drawType) {
                case DrawTypes.POINT:
                    state.drawFeature = new DrawFeature([], FeatureTypes.POINT, DrawSource.DEFAULT)
                    break;
                case DrawTypes.LINESTRING:
                    state.drawFeature = new DrawFeature([], FeatureTypes.LINESTRING, DrawSource.DEFAULT)
                    break;
                case DrawTypes.POLYGON:
                    state.drawFeature = new DrawFeature([], FeatureTypes.POLYGON, DrawSource.DEFAULT)
                    break;
                default:
                    break;
            }
        },
        setTextStatus: (state: DrawState, action) => {
            state.text = action.payload;
        },
        addPoint: (state: DrawState, action) => {
            state.drawFeature?.coordinates.push(action.payload);
        },
        removePoint: (state: DrawState) => {
            state.drawFeature?.coordinates.pop();
        },
        endDrawing(state: DrawState, action) {
            state.drawType = DrawTypes.DEFAULT;
            state.drawFeature = action.payload;
            state.text = true;
        }
    }
})

export const { startDrawing, setTextStatus, endDrawing } = selectionSlice.actions;
export default selectionSlice.reducer;